module.exports = __webpack_public_path__ + "img/g3brasil.ace1c90e.png";